var html = $('html');

$(function () {
    darkMode();
    expandLang();
    whiteLogo();
    carousel();
    video();
    author();
    offCanvas();
    clickMore();
    formSubmit();
});

function clickMore() {
    document.querySelectorAll(".click.more").forEach((e => {
        e.addEventListener("click", (e => {
            const t = e.currentTarget.parentNode.querySelector(".extendable"),
                n = e.currentTarget.parentNode.querySelector(".clamped");
            t.classList.toggle("open"),
            n.classList.toggle("open"),
            e.currentTarget.classList.add("hidden")
        }))
    })),
    document.querySelectorAll(".click.less").forEach((e => {
        e.addEventListener("click", (e => {
            const t = e.currentTarget.parentNode.parentNode.querySelector(".extendable"),
                n = e.currentTarget.parentNode.parentNode.querySelector(".clamped");
            t.classList.toggle("open"),
            n.classList.toggle("open"),
            e.currentTarget.parentNode.parentNode.querySelector(".click.more").classList.remove("hidden")
        }))
    }));
}

function darkMode() {
    $('.toggle-track').on('click', function () {
        if (html.hasClass('dark-mode')) {
            html.removeClass('dark-mode');
            localStorage.setItem('alto_dark', false);
        } else {
            html.addClass('dark-mode');
            localStorage.setItem('alto_dark', true);
        }
    });
}

function expandLang() {
    $('.langswitch').on('click', function () {
        $(this).toggleClass('extended');
    });
}

function whiteLogo() {
    if (typeof gh_white_logo != 'undefined') {
        var whiteImage = '<img class="logo-image white" src="' + gh_white_logo + '">';
        $('.logo').append(whiteImage);
    }
}

function carousel() {
    var carousel = $('.carousel');
    var postImage = carousel.find('.post-image');
    var imageHeight, nav;

    function moveNav() {
        imageHeight = postImage.height();
        if (!nav) {
            nav = carousel.find('.owl-prev, .owl-next');
        }
        nav.css({
            top: imageHeight / 2 + 'px',
            opacity: 1,
        });
    }

    carousel.owlCarousel({
        dots: false,
        margin: 20,
        nav: true,
        navText: [
            '<i class="icon icon-chevron-left"></i>',
            '<i class="icon icon-chevron-right"></i>',
        ],
        onInitialized: function () {
            moveNav();
        },
        onResized: function () {
            moveNav();
        },
        responsive: {
            0: {
                items: 1,
            },
            768: {
                items: 3,
            },
            992: {
                items: 4,
            },
        },
    });
}

function video() {
    'use strict';
    $('.post-content').fitVids();
}

function author() {
    $('.author-name').on('click', function () {
        $(this).next('.author-social').toggleClass('enabled');
    });
}

function offCanvas() {
    var burger = jQuery('.burger');
    var canvasClose = jQuery('.canvas-close');

    jQuery('.nav-list').slicknav({
        label: '',
        prependTo: '.mobile-menu',
    });

    burger.on('click', function () {
        html.toggleClass('canvas-opened');
        html.addClass('canvas-visible');
        dimmer('open', 'medium');
    });

    canvasClose.on('click', function () {
        if (html.hasClass('canvas-opened')) {
            html.removeClass('canvas-opened');
            dimmer('close', 'medium');
        }
    });

    jQuery('.dimmer').on('click', function () {
        if (html.hasClass('canvas-opened')) {
            html.removeClass('canvas-opened');
            dimmer('close', 'medium');
        }
    });

    jQuery(document).keyup(function (e) {
        if (e.keyCode == 27 && html.hasClass('canvas-opened')) {
            html.removeClass('canvas-opened');
            dimmer('close', 'medium');
        }
    });
}

function dimmer(action, speed) {
    'use strict';

    var dimmer = jQuery('.dimmer');

    switch (action) {
        case 'open':
            dimmer.fadeIn(speed);
            break;
        case 'close':
            dimmer.fadeOut(speed);
            break;
    }
}

function formSubmit() {
    const eventForm = document.getElementById("event-form");
    const membershipForm = document.getElementById("membership-form")
    const submitLabel = document.getElementById("submit-label");
    const submitDone = document.getElementById("submit-done");
    const submitError = document.getElementById("submit-err");
    const submitButton = document.querySelector(".submit-captcha .button");
    // const fbSuccess = document.getElementById("fb-success");
    // const fbError = document.getElementById("fb-error");

    function onSuccess() {
        const arrow = document.getElementById("arrow");
        const spinner = document.getElementById("spinner");
        const checkmark = document.getElementById("checkmark");
        arrow.classList.add("hidden");
        submitLabel.classList.add("hidden");
        submitError.classList.add("hidden");
        spinner.classList.add("hidden");
        submitDone.classList.remove("hidden");
        checkmark.classList.remove("hidden");
        // fbSuccess.classList.remove("hidden");
        grecaptcha.reset();
    }

    function onError() {
        const arrow = document.getElementById("arrow");
        const spinner = document.getElementById("spinner");
        const checkmark = document.getElementById("checkmark");
        arrow.classList.add("hidden");
        submitLabel.classList.add("hidden");
        spinner.classList.add("hidden");
        submitDone.classList.add("hidden");
        // fbSuccess.classList.add("hidden");
        checkmark.classList.add("hidden");
        submitError.classList.remove("hidden");
        submitButton.classList.add("error");
        // fbError.classList.remove("hidden")
    }

    function onSubmit() {
        const arrow = document.getElementById("arrow");
        const spinner = document.getElementById("spinner");
        const captchaBox = document.getElementsByClassName("g-recaptcha")[0].children[0];
        captchaBox.classList.remove("error");
        arrow.classList.add("hidden");
        spinner.classList.remove("hidden");
        submitButton.classList.remove("error");
        // fbError.classList.add("hidden")
    }

    function sendData(form, endpoint) {
        onSubmit();

        const xhr = new XMLHttpRequest();

        // Bind the FormData object and the form element
        const formData = new FormData(form);

        let object = {};
        formData.forEach((value, key) => object[key] = value);
        const json = JSON.stringify(object);

        xhr.addEventListener("load", function (event) {
            if (event.target.status === 200) onSuccess();
            else onError();
        });

        xhr.addEventListener("error", function (event) {
            onError();
        });

        xhr.open("POST", "/" + endpoint);
        xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
        xhr.send(json);
        
        plausible(endpoint);
    }

    function submitCallback(event, form, endpoint) {
        event.preventDefault();

        const solved = grecaptcha.getResponse();
        if (!solved) {
            const captchaBox = document.getElementsByClassName("g-recaptcha")[0].children[0];
            captchaBox.classList.add("error");
            return;
        }

        sendData(form, endpoint);
    }

    // register event listeners
    if (eventForm != null) {
        eventForm.addEventListener("submit", (event) => submitCallback(event, eventForm, "signup"));
    }
    if (membershipForm != null) {
        membershipForm.addEventListener("submit", (event) => submitCallback(event, membershipForm, "register"));
    }
}